export class GidUtil {
    /**
     * Formats Omniva GID to person code number (EPEE12345678900 -> 12345678900)
     */
    static personCodeFromFgid(input) {
        if (!input || input.length < 3) {
            return '';
        }
        return input.substring(2, input.length);
    }

    static customerCodeFromJgid(input) {
        if (!input || input.length < 5) {
            return '';
        }
        return input.substring(4, input.length);
    }

    static codeFromGid(input, isPerson) {
        if (isPerson) {
            return GidUtil.personCodeFromFgid(input);
        }
        return GidUtil.customerCodeFromJgid(input);
    }

    static countryFromJgid(input) {
        if (!input || input.length < 4) {
            return '';
        }
        return input.substring(2, 4).toUpperCase();
    }

    static countryFromGid(input, isPerson) {
        if (isPerson) {
            return GidUtil.countryFromFgid(input);
        }
        return GidUtil.countryFromJgid(input);
    }

    static countryFromFgid(input) {
        if (!input || input.length < 2) {
            return '';
        }
        return input.substring(0, 2).toUpperCase();
    }

    static personCodeToFgid(code, country) {
        if (!code) {
            return '';
        }
        if (!country) {
            country = 'EE';
        }
        return country.toUpperCase() + code;
    }

    static generateJgid(code) {
        return 'EPEE' + code.toUpperCase();
    }
}

export default GidUtil;


// WEBPACK FOOTER //
// ./src/main/ui/core/application/util/GIDUtil.ts